import React, { useEffect } from "react";

import { makeStyles, Theme } from "@material-ui/core/styles";
import {
  CircularProgress,
  Grid,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableRow,
  Typography,
} from "@material-ui/core";
import {
  Bar,
  Line,
  CartesianGrid,
  XAxis,
  YAxis,
  Tooltip,
  ComposedChart,
  ResponsiveContainer,
} from "recharts";
import { DateTime } from "luxon";
import { postRequest } from "../../../apis/axiosAction";
import HighlightOffIcon from "@material-ui/icons/HighlightOff";
import {
  getOneVisionData,
  ONE_VISION_BIG_RECORD,
  ONE_VISION_DATA,
  ONE_VISION_SCORE_DATA,
} from "./OneVisionDataOperation";
import { userLogging } from "../../../apis/userLog";
import OneVisionDialog from "../OneVisionDialog";


const useStyles = makeStyles((theme: Theme) => ({
  datePane: {
    backgroundColor: "lightgray",
    padding: 12,
  },
  firstRowCell: {
    [theme.breakpoints.down("md")]: {
      width: "3%",
    },
    [theme.breakpoints.up("lg")]: {
      width: "2.9%",
    },
    padding: "6px 2px",
  },
  secondRowCell: {
    [theme.breakpoints.down("md")]: {
      width: "8%",
    },
    [theme.breakpoints.up("lg")]: {
      width: "8%",
    },
    padding: "6px 1px",
    fontSize: "11px",
    fontWeight: "bold",
  },
  cell: {
    [theme.breakpoints.down("md")]: {
      width: "5%",
    },
    [theme.breakpoints.up("lg")]: {
      width: "9.4%",
    },
    padding: "10px 5px",
    fontSize: "18px",
  },
  spaceCell: {
    [theme.breakpoints.down("md")]: {
      width: "4.5%",
    },
    [theme.breakpoints.up("lg")]: {
      width: "4.5%",
    },
    padding: "0px",
  },
  totalColor: {
    color: "#82ca9d",
    fontSize: "20px",
  },
  score1Color: {
    color: "#8884d8",
    fontSize: "20px",
  },
  score2Color: {
    color: "green",
    fontSize: "20px",
  },
  score3Color: {
    color: "coral",
    fontSize: "20px",
  },
  score4Color: {
    color: "skyblue",
    fontSize: "20px",
  },
  score5Color: {
    color: "peru",
    fontSize: "20px",
  },
  score6Color: {
    color: "plum",
    fontSize: "20px",
  },
  score7Color: {
    color: "gold",
    fontSize: "20px",
  },
  score8Color: {
    color: "pink",
    fontSize: "20px",
  },
  customTooltip: {
    padding: "5px",
    border: "1px solid lightgray",
    backgroundColor: "rgba(255,255,255,0.9)",
    pointerEvents: "all",
    borderRadius: "5%",
  },
  customTooltipContent: {
    listStyle: "none",
  },
}));

// 小数点以下を四捨五入
const roundOffDecimal = (num: any) => {
  let value: number = Number(num);
  if (value) {
    return Math.round(value);
  }
  return 0;
};

const OneVisionResultGraphs2: React.FC<{
  tenpoCode: string;
  oneVisionId: string;
  lastOneVisionId: string;
}> = ({ tenpoCode, oneVisionId, lastOneVisionId }) => {
  const classes = useStyles();

  const [dataMapList, setdataMapList] = React.useState<any[]>([]);
  // TODO zoCode,taragetDateの初期値を設定
  const [tenpCcode] = React.useState("");
  const [targetDate] = React.useState("");
  const [activeTooltip, setActiveTooltip] = React.useState(true);
  const [loading, setLoading] = React.useState(false);
  const [dialogMessage, setDialogMessage] = React.useState<any[]>([]);
  const [dialogFlg, setDialogFlg] = React.useState(false);

  // ダイアログ表示
  const dialogOK = () => {
    setDialogFlg(false);
  };
  // 検索実行処理
  useEffect(() => {
    setLoading(true);
    userLogging("店舗経営診断", "集計#初期表示", oneVisionId);
    getOneVisionData(tenpoCode, oneVisionId, lastOneVisionId).then(
      (res: ONE_VISION_DATA) => {
        let appDate = res.approve_day
          ? DateTime.fromFormat(res.approve_day, "yyyyMMdd")
          : DateTime.local();
        const apiParams = {
          "api-name": "summary",
          target_date: appDate.toLocaleString() + " 00:00:00",
          tenpo_code: tenpoCode,
        };

        // 当週分の計算
        const rowItemList: ONE_VISION_BIG_RECORD[] = res.rows || [];
        const scoreData: ONE_VISION_SCORE_DATA = res.score_data;

        interface LOCAL_SCORE {
          maxScore: number;
          score: number;
        }
        function getThisMonthData() {
          let data001 = { maxScore: 0, score: 0 };
          let data002 = { maxScore: 0, score: 0 };
          let data003 = { maxScore: 0, score: 0 };
          let data004 = { maxScore: 0, score: 0 };
          let data005 = { maxScore: 0, score: 0 };
          let data006 = { maxScore: 0, score: 0 };
          let resultData: any = {};

          resultData["total"] = scoreData.total_score;//calculationTotalScore(rowItemList);

          console.log("length:"+rowItemList.length);
          console.log("total:"+resultData["total"]);
          console.log(res.rows);
          console.log(scoreData);

          if (scoreData && scoreData.scores) {
            for (let i = 0; i < scoreData.scores.length; i++) {
              let itemScore = Number(scoreData.scores[i].score);
              let maxScore = 20;//Number(scoreData.scores[i].max_score);
              if (scoreData.scores[i].no === "1") {
                setScore(data001, itemScore, maxScore);
              }
              if (scoreData.scores[i].no === "2") {
                setScore(data002, itemScore, maxScore);
              }
              if (scoreData.scores[i].no === "3") {
                setScore(data003, itemScore, maxScore);
              }
              if (scoreData.scores[i].no === "4") {
                setScore(data004, itemScore, maxScore);
              }
              if (scoreData.scores[i].no === "5") {
                setScore(data005, itemScore, maxScore);
              }
              if (scoreData.scores[i].no === "その他") {
                setScore(data006, itemScore, -35);
              }
              // if (scoreData.scores[i].no === "5") {
              //   setScore(data005, itemScore, maxScore);
              // }
            }
          }
          // for (let i = 0; i < rowItemList.length; i++) {
          //   for (let j = 0; j < rowItemList[i].rows.length; j++) {
          //     let scoreList = rowItemList[i].rows[j].score_list || [0];
          //     let itemScore = Number(rowItemList[i].rows[j].score);
          //     let itemMaxScore = Number(scoreList[0]);
          //     if (rowItemList[i].rows[j].big_item_id === 1) {
          //       setScore(data001, itemScore, itemMaxScore);
          //     }
          //     if (rowItemList[i].rows[j].big_item_id === 2) {
          //       setScore(data002, itemScore, itemMaxScore);
          //     }
          //     if (rowItemList[i].rows[j].big_item_id === 3) {
          //       setScore(data003, itemScore, itemMaxScore);
          //     }
          //     if (rowItemList[i].rows[j].big_item_id === 4) {
          //       setScore(data004, itemScore, itemMaxScore);
          //     }
          //   }
          // }

          resultData["score001"] = calcScore(data001);
          resultData["score002"] = calcScore(data002);
          resultData["score003"] = calcScore(data003);
          resultData["score004"] = calcScore(data004);
          resultData["score005"] = calcScore(data005);
          resultData["score006"] = percentScore(data006);//calcScore(data006);
          return resultData;
        }
        function setScore(
          scoreObj: LOCAL_SCORE,
          score: number,
          maxScore: number
        ) {
          scoreObj.maxScore += maxScore;
          scoreObj.score += score;
        }

        function calcScore(scoreObj: LOCAL_SCORE) {
          if (scoreObj.maxScore === 0) {
            return 0;
          }
          return Math.round((scoreObj.score / scoreObj.maxScore) * 100);
        }
      
        function percentScore(scoreObj: LOCAL_SCORE) {
          if (scoreObj.score === 0) {
            return 100;
          }
          return Math.round(100 - ((scoreObj.score / scoreObj.maxScore) * 100));
        }

        const url = process.env.REACT_APP_API_URL_J11SPB22 + "onevision/summary";
        postRequest(url, apiParams)
          .then((res) => {
            let dataList: any[] = res.data.dataList;

            let thisMonthDate: any = getThisMonthData();
            if (dataList) {
              for (let i = 0; i < dataList.length; i++) {
                var y = parseInt(dataList[i].month.substr(1, 4));
                var m = parseInt(dataList[i].month.substr(5, 2));
                var d = parseInt(dataList[i].month.substr(7, 2));
                var dt = y + "/" + m + "/" + d;
                dataList[i].month = dt;
                if (i === 0) {
                  dataList[i].total = thisMonthDate.total;
                  dataList[i].score001 = thisMonthDate.score001;
                  dataList[i].score002 = thisMonthDate.score002;
                  dataList[i].score003 = thisMonthDate.score003;
                  dataList[i].score004 = thisMonthDate.score004;
                  dataList[i].score005 = thisMonthDate.score005;
                  dataList[i].score006 = thisMonthDate.score006;
                }
                dataList[i].total = roundOffDecimal(
                  dataList[i].total
                ).toLocaleString(undefined, { maximumFractionDigits: 2 });
                dataList[i].score001 = roundOffDecimal(
                  dataList[i].score001
                ).toLocaleString(undefined, { maximumFractionDigits: 2 });
                dataList[i].score002 = roundOffDecimal(
                  dataList[i].score002
                ).toLocaleString(undefined, { maximumFractionDigits: 2 });
                dataList[i].score003 = roundOffDecimal(
                  dataList[i].score003
                ).toLocaleString(undefined, { maximumFractionDigits: 2 });
                dataList[i].score004 = roundOffDecimal(
                  dataList[i].score004
                ).toLocaleString(undefined, { maximumFractionDigits: 2 });
                dataList[i].score005 = roundOffDecimal(
                  dataList[i].score005
                ).toLocaleString(undefined, { maximumFractionDigits: 2 });
                dataList[i].score006 = roundOffDecimal(
                  dataList[i].score006
                ).toLocaleString(undefined, { maximumFractionDigits: 2 });
              }
              dataList.reverse();
              setdataMapList(dataList);
            }
          })
          .catch((r) => {
            userLogging(
              "店舗確認表",
              "集計#初期表示エラー",
              oneVisionId + " " + JSON.stringify(r)
            );
            setDialogMessage([String(r)]);
            setDialogFlg(true);
          })
          .finally(() => {
            setLoading(false);
          });
      }
    );
  }, [tenpCcode, targetDate]);

  const CustomTooltip = ({ active, payload, label }: any) => {
    if (active && payload && payload.length && activeTooltip) {
      return (
        <div className={classes.customTooltip}>
          <div style={{ textAlign: "right" }}>
            <IconButton onClick={() => setActiveTooltip(false)} size={"small"}>
              <HighlightOffIcon />
            </IconButton>
          </div>
          <li className={classes.customTooltipContent}>{`${label}`}</li>
          {payload.map((payload: any, index: any) => {
            let newName = "";
            let color;
            switch (payload.name) {
              case "total":
                newName = "合計";
                color = "#82ca9d";
                break;
              case "score001":
                newName = "募集・採用・面接";
                color = "#8884d8";
                break;
              case "score002":
                newName = "労務管理・職場環境";
                color = "green";
                break;
              case "score003":
                newName = "教育・店内体制";
                color = "coral";
                break;
              case "score004":
                newName = "従業員全員参加型経営";
                color = "skyblue";
                break;
              case "score005":
                newName = "基本４原則";
                color = "peru";
                break;
              case "score006":
                newName = "遵守事項";
                color = "plum";
                break;
            }
            return (
              <li
                className={classes.customTooltipContent}
                style={{ color: color }}
                key={index.toString()}
              >
                {newName +
                  "：" +
                  new Intl.NumberFormat("en").format(payload.value) +
                  "%"}
              </li>
            );
          })}
        </div>
      );
    }
    return null;
  };

  const handleActiveTooltip = () => {
    setActiveTooltip(true);
  };

  // ReactStrinctModeでエラーが出ているけどいったん保留 React.StrictMode → React.Fragment にすれば直る
  return (
    <Grid container justify="center">
      {/* {loading && <div className={stylesClasses.overLayer}></div>} */}
      {loading && (
        <CircularProgress
          // className={stylesClasses.circularProgress}
          size={120}
        />
      )}
      <Grid container item xs={12} justify="center">
        <Grid container item xs={12} justify="flex-start">
          <Typography color="textSecondary" gutterBottom>
            ▼個店数値
          </Typography>
        </Grid>
        <Grid container item xs={12} justify="flex-start">
          <>
            <ResponsiveContainer height={400}>
              <ComposedChart
                data={dataMapList}
                margin={{ top: 30, right: 0, bottom: 5, left: 80 }}
              >
                <CartesianGrid stroke="#f5f5f5" />
                <XAxis
                  dataKey="month"
                  scale="band"
                  label={{
                    value: "(月)",
                    dx: 50,
                    position: "insideBottomRight",
                  }}
                />
                <YAxis
                  yAxisId={1}
                  domain={[0, 100]}
                  tickCount={5}
                  label={{
                    value: "(合計)",
                    position: "insideTopLeft",
                    dy: -30,
                  }}
                />
                <YAxis
                  yAxisId={2}
                  orientation="right"
                  domain={[0, 100]}
                  tickCount={5}
                  tickFormatter={(tickItem) => tickItem + "%"}
                  label={{
                    value: "(得点率)",
                    position: "insideTopLeft",
                    dy: -30,
                  }}
                />
                <Tooltip trigger="click" content={<CustomTooltip />} />
                <Bar
                  dataKey="total"
                  barSize={20}
                  fill="#82ca9d"
                  yAxisId={1}
                  onClick={() => {
                    handleActiveTooltip();
                  }}
                />
                <Line
                  type="linear"
                  dataKey="score001"
                  stroke="#8884d8"
                  yAxisId={2}
                  onClick={() => {
                    handleActiveTooltip();
                  }}
                />
                <Line
                  type="linear"
                  dataKey="score002"
                  stroke="green"
                  yAxisId={2}
                  onClick={() => {
                    handleActiveTooltip();
                  }}
                />
                <Line
                  type="linear"
                  dataKey="score003"
                  stroke="coral"
                  yAxisId={2}
                  onClick={() => {
                    handleActiveTooltip();
                  }}
                />
                <Line
                  type="linear"
                  dataKey="score004"
                  stroke="skyblue"
                  yAxisId={2}
                  onClick={() => {
                    handleActiveTooltip();
                  }}
                />
                <Line
                  type="linear"
                  dataKey="score005"
                  stroke="peru"
                  yAxisId={2}
                  onClick={() => {
                    handleActiveTooltip();
                  }}
                />
                <Line
                  type="linear"
                  dataKey="score006"
                  stroke="plum"
                  yAxisId={2}
                  onClick={() => {
                    handleActiveTooltip();
                  }}
                />
              </ComposedChart>
            </ResponsiveContainer>
          </>
        </Grid>
        <Grid container item xs={12} justify="flex-start">
          <Table aria-label="a dense table">
            <TableBody>
              <TableRow>
                <TableCell className={classes.firstRowCell}>
                  <span className={classes.totalColor}>●</span>
                </TableCell>
                <TableCell className={classes.secondRowCell} align="left">
                  合計
                </TableCell>
                {dataMapList.map((data: any, index: number) => (
                  <TableCell
                    className={classes.cell}
                    align="center"
                    key={index.toString()}
                  >
                    {data.total}
                  </TableCell>
                ))}
                <TableCell className={classes.spaceCell}>　</TableCell>
              </TableRow>
              <TableRow>
                <TableCell className={classes.firstRowCell}>
                  <span className={classes.score1Color}>●</span>
                </TableCell>
                <TableCell className={classes.secondRowCell} align="left">
                募集・採用・面接
                </TableCell>
                {dataMapList.map((data: any, index: number) => (
                  <TableCell
                    className={classes.cell}
                    align="center"
                    key={index.toString()}
                  >
                    {data.score001}
                  </TableCell>
                ))}
                <TableCell className={classes.spaceCell}>　</TableCell>
              </TableRow>
              <TableRow>
                <TableCell className={classes.firstRowCell}>
                  <span className={classes.score2Color}>●</span>
                </TableCell>
                <TableCell className={classes.secondRowCell} align="left">
                労務管理・職場環境
                </TableCell>
                {dataMapList.map((data: any, index: number) => (
                  <TableCell
                    className={classes.cell}
                    align="center"
                    key={index.toString()}
                  >
                    {data.score002}
                  </TableCell>
                ))}
                <TableCell className={classes.spaceCell}>　</TableCell>
              </TableRow>
              <TableRow>
                <TableCell className={classes.firstRowCell}>
                  <span className={classes.score3Color}>●</span>
                </TableCell>
                <TableCell className={classes.secondRowCell} align="left">
                教育・店内体制
                </TableCell>
                {dataMapList.map((data: any, index: number) => (
                  <TableCell
                    className={classes.cell}
                    align="center"
                    key={index.toString()}
                  >
                    {data.score003}
                  </TableCell>
                ))}
                <TableCell className={classes.spaceCell}>　</TableCell>
              </TableRow>
              <TableRow>
                <TableCell className={classes.firstRowCell}>
                  <span className={classes.score4Color}>●</span>
                </TableCell>
                <TableCell className={classes.secondRowCell} align="left">
                従業員全員参加型経営
                </TableCell>
                {dataMapList.map((data: any, index: number) => (
                  <TableCell
                    className={classes.cell}
                    align="center"
                    key={index.toString()}
                  >
                    {data.score004}
                  </TableCell>
                ))}
                <TableCell className={classes.spaceCell}>　</TableCell>
              </TableRow>
              <TableRow>
                <TableCell className={classes.firstRowCell}>
                  <span className={classes.score5Color}>●</span>
                </TableCell>
                <TableCell className={classes.secondRowCell} align="left">
                基本４原則
                </TableCell>
                {dataMapList.map((data: any, index: number) => (
                  <TableCell
                    className={classes.cell}
                    align="center"
                    key={index.toString()}
                  >
                    {data.score005}
                  </TableCell>
                ))}
                <TableCell className={classes.spaceCell}>　</TableCell>
              </TableRow>
              <TableRow>
                <TableCell className={classes.firstRowCell}>
                  <span className={classes.score6Color}>●</span>
                </TableCell>
                <TableCell className={classes.secondRowCell} align="left">
                遵守事項
                </TableCell>
                {dataMapList.map((data: any, index: number) => (
                  <TableCell
                    className={classes.cell}
                    align="center"
                    key={index.toString()}
                  >
                    {data.score006}
                  </TableCell>
                ))}
                <TableCell className={classes.spaceCell}>　</TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </Grid>
      </Grid>
      {/* ダイアログ */}
      <OneVisionDialog
        msg={dialogMessage}
        isOpen={dialogFlg}
        doOK={dialogOK}
        doNo={dialogOK}
        isAlert={true}
      />
    </Grid>
  );
};

export default OneVisionResultGraphs2;
